import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-final-form';
import { toggleMultiCity } from '@websky/core/src/SearchForm/store/segments/actions';
import { isMultiCity as getIsMultiCity } from '@websky/core/src/SearchForm/store/segments/selectors';
import Checkbox from '../Checkbox/Checkbox';
const MultiCity = React.memo(() => {
    const { t } = useTranslation('SearchForm');
    const form = useForm();
    const dispatch = useDispatch();
    const isMultiCity = useSelector(getIsMultiCity);
    const onChange = () => {
        dispatch(toggleMultiCity());
        form.reset();
    };
    return (React.createElement(Checkbox, { label: t(isMultiCity ? 'Set simple route' : 'Set multi city route'), checked: isMultiCity, onChange: onChange }));
});
export default MultiCity;
